import { apiSlice } from '../../api';
import type { UpdateAddressDTO, UpdateAddressResult } from './types';

export const adminAddressesEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => {
    return {
      updateAddress: build.mutation<UpdateAddressResult, UpdateAddressDTO>({
        query: ({ addressId, body }) => ({
          url: `/admin/v1/addresses/${addressId}`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['CurrentProfile'],
      }),
    };
  },
});

export const { useUpdateAddressMutation } = adminAddressesEndpoints;

export type AdminAddressesController = typeof adminAddressesEndpoints;
